import React from "react";
import {
  useLink,
  useLogin,
  useRouterContext,
  useRouterType,
} from "@refinedev/core";
import {
  Row,
  Col,
  Card,
  Typography,
  Form,
  Input,
  Button,
  theme,
  Layout,
} from "antd";
import { containerStyles, layoutStyles, titleStyles } from "./styles";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { TextField, ThemedTitleV2 } from "@refinedev/antd";
import { LoadingOutlined } from "@ant-design/icons";

const { useToken } = theme;

const { Title } = Typography;

export interface ILoginForm {
  username: string;
  password: string;
  remember: boolean;
}

export const Login: React.FC = () => {
  const { token } = useToken();

  const [form] = Form.useForm<ILoginForm>();

  const { mutate: login, isLoading } = useLogin<ILoginForm>();

  const CardTitle = (
    <Title
      level={3}
      style={{
        color: token.colorPrimaryTextHover,
        ...titleStyles,
      }}
    >
      Sign in to your account
    </Title>
  );

  const Link = useLink();
  const { Link: LegacyLink } = useRouterContext();

  const routerType = useRouterType();

  const ActiveLink = routerType === "legacy" ? LegacyLink : Link;

  return (
    <Layout style={layoutStyles}>
      <Row
        justify="center"
        align={"middle"}
        style={{
          padding: "16px 0",
          minHeight: "100dvh",
          paddingTop: "16px",
        }}
      >
        <Col xs={22}>
          <div className="container">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "32px",
                fontSize: "20px",
              }}
            >
              <ThemedTitleV2 collapsed={false} />
            </div>
            <Card
              title={CardTitle}
              headStyle={{ borderBottom: 0 }}
              style={{
                ...containerStyles,
                backgroundColor: token.colorBgElevated,
              }}
            >
              <Form<ILoginForm>
                layout="vertical"
                form={form}
                onFinish={(values) => {
                  login(values);
                }}
                requiredMark={false}
                initialValues={{ remember: false }}
                >
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[{ required: true, type: "email" }]}
                >
                  <Input size="large" placeholder="Email" />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[{ required: true }]}
                  style={{ marginBottom: "12px" }}
                >
                  <Input type="password" placeholder="●●●●●●●●" size="large" />
                </Form.Item>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "24px",
                  }}
                >
                  <Form.Item
                    name="remember"
                    valuePropName="checked" // Ensure checkbox state is handled
                    noStyle
                  >
                    <Checkbox style={{ fontSize: "12px" }}>
                      <TextField value='Remember me' />
                    </Checkbox>
                  </Form.Item>
                  <ActiveLink
                    style={{
                      color: token.colorPrimaryTextHover,
                      fontSize: "12px",
                      marginLeft: "auto",
                    }}
                    to="/forgot-password"
                  >
                    Forgot password?
                  </ActiveLink>
                </div>

                <Button type="primary" size="large" htmlType="submit" block>
                  {isLoading ? (
                    <LoadingOutlined style={{ fontSize: 24, color: "#FFF" }} spin />) : (
                    <>Sign in</>
                  )}
                </Button>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};
